module.exports = __webpack_public_path__ + "img/preview-whatsapp.6ca55e2e.png";